import { render, staticRenderFns } from "./ProductsSelectionCard.vue?vue&type=template&id=9181c9c2&scoped=true&"
import script from "./ProductsSelectionCard.vue?vue&type=script&lang=js&"
export * from "./ProductsSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSelectionCard.vue?vue&type=style&index=0&id=9181c9c2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9181c9c2",
  null
  
)

export default component.exports